import "./TrialInformation.css";

import { useSelector } from "react-redux";

const ExperimentItem = ({ experiment }) => {
  const numberOfPlots = experiment?.meta?.number_plots;
  const blockName =
    experiment?.features?.features?.[3]?.properties?.block_name || "Experiment";

  if (!numberOfPlots) return null;

  return (
    <div className="experiment-item">
      <div className="d-flex align-items-center">
        <div className="rounded-1 me-2 plot-indicator" />
        <span>{blockName}</span>
      </div>
      <div className="plots-occurence">{numberOfPlots} plots</div>
    </div>
  );
};

const FieldMapDetails = () => {
  const experiments = useSelector(({ resultMap }) => resultMap.experiments);

  return (
    <div className="fieldmap-description">
      {experiments?.map((exp, index) => (
        <ExperimentItem key={index} experiment={exp} />
      ))}
    </div>
  );
};

export default FieldMapDetails;
